import { connect } from 'react-redux';
import { OPEN_SEARCH } from '../../../../shared/actions/types';
import SearchButton from './searchButton';
import setListContainerWidth from '../../../../shared/actions/setListContainerWidth';
import { SIDE_PANEL_TRANSITION } from '../../../constants';

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({
  openSearch: () => {
    dispatch({ type: OPEN_SEARCH });
    setTimeout(() => dispatch(setListContainerWidth()), SIDE_PANEL_TRANSITION);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchButton);
